import { render, staticRenderFns } from "./RestaurantsComponent.vue?vue&type=template&id=7a2738e2&scoped=true&"
import script from "./RestaurantsComponent.vue?vue&type=script&lang=js&"
export * from "./RestaurantsComponent.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantsComponent.vue?vue&type=style&index=0&id=7a2738e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2738e2",
  null
  
)

export default component.exports